import { render } from "./DropdownAnnotation.vue?vue&type=template&id=2f7d68c2&scoped=true"
import script from "./DropdownAnnotation.vue?vue&type=script&lang=js"
export * from "./DropdownAnnotation.vue?vue&type=script&lang=js"

import "./DropdownAnnotation.vue?vue&type=style&index=0&id=2f7d68c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7d68c2"]])

export default __exports__